import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import gimp from "../assets/img/gimp.jpg";
import anki from "../assets/img/anki.png";
import flameshot from "../assets/img/flameshot.png";
import inkspace from "../assets/img/inkscape.png"
import vscode from "../assets/img/vscode.png";
import kturtle from "../assets/img/kturtle.png";
import audacity from "../assets/img/audacity.svg"
import notion from "../assets/img/notion.svg"
import cherry from "../assets/img/cherry.png"
import colorSharp from "../assets/img/color-sharp.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const creative = [
    {
      title: "Gimp",
      description: "",
      imgUrl: gimp,
    },
    {
      title: "InkSpace",
      description: "",
      imgUrl: inkspace,
    },
    {
      title: "Audacity",
      description: "",
      imgUrl: audacity,
    },
    
  ];

  const scholastic = [
    {
      title: "VsCode",
      description: "",
      imgUrl: vscode,
    },
    {
      title: "KTurtle",
      description: "",
      imgUrl: kturtle,
    },
    {
      title: "Anki",
      description: "",
      imgUrl: anki,
    },
   
  ];

  const productive = [
    {
      title: "Flameshot",
      description: "",
      imgUrl: flameshot,
    },
    {
      title: "Cherry Tree",
      description: "",
      imgUrl: cherry,
    },
    {
      title: "Evernote",
      description: "",
      imgUrl: notion,
    },
   
  ];

  return (
    <section className="project" id="tools">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>20+ Tools</h2>
                <p>At EdOS, we understand the importance of providing a reliable and efficient platform for students and teachers to excel in their educational pursuits. That's why we've carefully selected and optimized a suite of handpicked software that caters to the unique needs of our users while ensuring a lightweight and robust operating system.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Scholastic</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Creative</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Productive</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          scholastic.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                    <Row>
                        {
                          creative.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                      </Tab.Pane>
                    <Tab.Pane eventKey="third">
                    <Row>
                        {
                          productive.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
